import React from "react";
import { Box, Kbd, Tooltip as ChakraTooltip, } from "@chakra-ui/react";
import Balancer from "@hightouchio/react-wrap-balancer";
import { Text } from "./text";
const macKeys = {
    mod: "⌘",
    command: "⌘",
    shift: "⇧",
    ctrl: "⌃",
    alt: "⌥",
};
const windowsKeys = {
    mod: "Ctrl",
    shift: "Shift",
    ctrl: "Ctrl",
    alt: "Alt",
};
const formatKeyboardShortcut = (shortcut) => {
    const keys = shortcut.split("+");
    const platform = typeof navigator === "object" && navigator.userAgent.includes("Mac")
        ? "mac"
        : "windows";
    if (platform === "mac") {
        return keys.map((key) => {
            return macKeys[key] ?? key.toUpperCase();
        });
    }
    return keys
        .map((key) => {
        return windowsKeys[key] ?? key.toUpperCase();
    })
        .join(" + ")
        .split(" ");
};
export function Tooltip({ isDisabled, children, placement = "top", message, keyboardShortcut, openSpeed = "immediate", }) {
    const formattedKeyboardShortcut = keyboardShortcut
        ? formatKeyboardShortcut(keyboardShortcut)
        : null;
    const wrappedChildren = (React.createElement(Box, { as: "span", display: "inline-block", tabIndex: isDisabled ? undefined : 0, width: "max-content", height: "max-content" }, children));
    if (isDisabled) {
        return wrappedChildren;
    }
    return (React.createElement(ChakraTooltip, { hasArrow: true, label: React.createElement(Box, { display: "flex", alignItems: "center", flexDirection: "column", gap: 1 },
            React.createElement(Text, { color: "white", wordBreak: "break-word" },
                React.createElement(Balancer, { ratio: 0.65 }, message)),
            formattedKeyboardShortcut && (React.createElement(Box, { as: "span", display: "flex", alignItems: "center", color: "gray.300", fontWeight: "normal", fontSize: "sm", gap: 0.5, whiteSpace: "nowrap" }, formattedKeyboardShortcut.map((shortcut) => {
                if (shortcut === "+") {
                    return shortcut;
                }
                return React.createElement(Kbd, { key: shortcut }, shortcut);
            })))), placement: placement, openDelay: openSpeed === "immediate" ? 0 : 500, motionProps: {
            initial: {
                scale: 0.9,
                opacity: 0,
            },
            variants: {
                enter: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                        type: "spring",
                        damping: 30,
                        stiffness: 1000,
                    },
                },
                exit: {
                    scale: 0.9,
                    opacity: 0,
                    transition: {
                        type: "spring",
                        duration: 0.15,
                    },
                },
            },
        } }, wrappedChildren));
}
